
  import { defineComponent, reactive, toRefs, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { useI18n } from 'vue-i18n';
  import { useRouter, useRoute } from 'vue-router';
  import 'vue3-carousel/dist/carousel.css';
  import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';

  export default defineComponent({
    name: 'News',
    components: { Carousel, Slide, Pagination, Navigation },
    setup() {
      const store = useStore();
      const i18n = useI18n();
      const router = useRouter();
      const route = useRoute();

      const state = reactive({
        loading: false,
        event: null,
      });

      onMounted(() => {
        let id: any = route.params.id;
        findEvent(id);
      });

      const findEvent = (id) => {
        state.loading = true;
        store.dispatch('moduleCommon/findEvent', {
          id: id,
        }).then((response) => {
          state.loading = false;
          state.event = response.data;
        }).catch(() => {
          state.loading = false;
        });
      };

      return {
        ...toRefs(state),
        store,
        i18n,
      };
    },
  });
